import { Card } from "components/common"
import AddReviewClientStaffHeader from "./addReviewClientStaffHeader"
import ReviewDetailCard from "./reviewDetailCard"
import { useLazyGetClientDetailQuery } from "features/clients/detail/api"
import { useEffect } from "react"

const AddReviewDetailCard = ({ client, entityToReview, data, preSelection = {}, entityApiMap }) => {
  const { preSelectMeeting, preSelectCall, preSelectLead, lead, meeting, callRecord } = preSelection
  const preselectType = preSelectMeeting ? "meeting" : preSelectCall ? "call" : preSelectLead ? "lead" : null
  const preSelectData = lead || callRecord || meeting

  const isPreselectEntityLoading =
    !!preselectType &&
    (!entityToReview ||
      (entityToReview === preselectType && !!preSelectData && !data && entityApiMap[preselectType]?.loading))

  const [
    getClientDetails,
    { data: clientData, isFetching: isFetchingClientDetails, isError: isClientDetailsError, refetch },
  ] = useLazyGetClientDetailQuery()

  useEffect(() => {
    if (client) {
      getClientDetails(client?.clientId ?? client?.id, true)
    }
  }, [client])

  return (
    <Card Shadow={false} className="mbe-24" bodyStyle={{ padding: 16 }} style={{ position: "sticky", top: 0 }}>
      <>
        <AddReviewClientStaffHeader client={clientData} isLoading={isFetchingClientDetails} />
        <ReviewDetailCard
          selectedEntity={entityToReview}
          data={data}
          client={clientData}
          isPreselectEntityLoading={isPreselectEntityLoading}
        />
      </>
    </Card>
  )
}

export default AddReviewDetailCard
